import React from "react";
import ActivityFeed from "../../interests-activities/activity-feed";

type Props = {
  interestID: string;
}

export const ActivityContent: React.FC<Props> = (props) => (
  <div className="panel panel-default">
    <div className="panel-heading">View application activity</div>
    <div className="panel-body">
      <ActivityFeed interestId={props.interestID} />
    </div>
  </div>
);
